
/**
 * 
 * @returns 
* Title Banner for Website used for announcements and welcoming visitors
*/
import Container from 'react-bootstrap/Container';
import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Pdf from '../images/Yardi_Delayed_Payments_LL Memo_2025.pdf';
import Pdf2 from '../images/254790_Lot_A_Loan_Program_Brochure.pdf';

export default function LoggedOutBanner()
{
    return(
        <div className='whiteFont '>         
            <Container className='text-center  m_gateway loggedInBanner'>
                <div>
                    <Row>
                        <Col xs={12} md={12} >
                            <h4 className='emphTitle1'>LOGIN TO VIEW PAYMENTS</h4>
                            <p className='emphTitle2'>
                                Log into this website using your username and password. If you have not created an account, please <a className='btn btn-primary'  href='/login'>Start Today</a>
                            </p> 
                        </Col>
                        <Col xs={12} md={12}>
                            <h4 className='emphTitle1'>TRACK ALL PAYMENTS</h4>
                            <p className='emphTitle2'>
                                View payments from Metro Housing Boston which include Section 8, MRVP, and RAFT/HOMEBASE payments. Send email to accounting.mailbox@metrohousingboston.org to look into missing or incorrect payments.
                            </p> 
                        </Col>
                        <Col xs={12} md={12}>
                            <h4 className='emphTitle1'>CREATE AN ACCOUNT AND LINK PREVIOUS PORTAL ACCOUNT TODAY</h4>
                            <p className='emphTitle2'>
                                Thank you for visiting the Metro Housing Property Management Portal. Please Login using your email address and password or create a new account below.
                            </p> 
                        </Col>
                    </Row>
                    <Row >
                        <Col xs={12} md={12} >
                            <h4 className='paddingBottom'>Looking to get started? </h4>
                            <a className='whiteFont emphTitle text-center m_register btn btnColor  ' href='/register'>Register Today</a>
                            <div className='whiteFont emphTitle2 '>
                                <p className='hide display-block'>2025 DELAYED Remittance Update:  <a className='btn btn-primary buttons' target='_blank' rel='noreferrer' href={Pdf} >Yardi_Delayed_Payments_LL Memo_2025</a></p>
                                <p className='display-block'>Loan Program Brochure Update:  <a className='btn btn-primary buttons' target='_blank' rel='noreferrer' href={Pdf2} >254790_Lot_A_Loan_Program_Brochure</a></p>

                                <p className='emphTitle2 hide'> We are actively working to resolve missing data and provide remittance details, the process is taking longer than expected due to the high volume of affected users.
                                    In the meantime, we recommend reaching out to your accounting team for the most accurate and up-to-date information regarding your payments. Rest assured, we are handling these cases individually and will continue updating the Portal as additional payment data becomes available from the new system.
                                    If you have any further questions, please do not hesitate to contact us.
                                </p>

                                <h5 className='whiteFont emphTitle2 hide'>
                                    We wanted to inform you of a potential delay in rental subsidy payments for the Section 8 and MRVP scheduled to be issued to you in early February. 
                                    Please visit the Messages section for more information<a className='whiteFont emphTitle text-center m_register btn btnColor ' href='/main'>MESSAGES AND ALERTS</a>

                                </h5>

                            </div>   
                        </Col>
                    </Row>
                </div>
            </Container>
            <br></br>

        </div>
    );
}